if(window.location.pathname.replace(https,'') == "/"){
    require('./view/index');
}
if(window.location.pathname.replace(https,'') == "/gracias"){
    require('./view/thanks');
}